import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { Size } from 'choerodon-ui/lib/_util/enum';
import { $l } from '../locale-context';
import ObserverNumberField from '../number-field/NumberField';
const QuickJumper = function (props) {
    const { prefixCls, value, onChange, disabled, gotoButton } = props;
    const [focused, setFocused] = useState(false);
    const handleFocus = useCallback(() => setFocused(true), []);
    const handleBlur = useCallback(() => setFocused(false), []);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: `${prefixCls}-quick-jumper` }, $l('Pagination', 'jump_to')),
        React.createElement("span", { className: classNames(`${prefixCls}-quick-jumper-input`, { [`${prefixCls}-quick-jumper-input-focused`]: focused }) },
            React.createElement(ObserverNumberField, { value: value, disabled: disabled, min: 1, onChange: onChange, onFocus: handleFocus, onBlur: handleBlur, size: Size.small, isFlat: true, border: false }),
            $l('Pagination', 'page')),
        gotoButton));
};
QuickJumper.displayName = 'QuickJumper';
export default QuickJumper;
